import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import * as momenttimezone from 'moment-timezone';

@Injectable()
export class LocationChecklistService implements OnInit {
  url = environment.configURI;
  private getCheckListData = '/vendor/siteinspection/';
  loginId: string;
  remediationNeeded: boolean;
  constructor(private httpClient: HttpClient, private userFriendlyMsgs: UserFriendlyMsgs) {
  }

  ngOnInit() {

  }
  getLocationChecklist(locationId, agentId) {
    return this.httpClient.get(this.url + this.getCheckListData + locationId + '/' + agentId)
      .catch(this.userFriendlyMsgs.errorHandler);
  }

  incidentTimeZone(date) {
    const setTime = new Date(date);
    setTime.setHours(19);
    setTime.setMinutes(59);
    setTime.setSeconds(59);
    const estTimeZone = "America/New_York";
    const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
    var testTimeZone = momenttimezone(setTime).tz(estTimeZone).format(format);
    /*** The following logic for Daylight Savings ***/
    if (testTimeZone.includes('-05:00')) {
      testTimeZone = testTimeZone.replace('19:59:59', '18:59:59');
    }
    return testTimeZone.toString();
  }

  saveLocationChecklist(data, locationId, loginId, agentId, documentData) {

    if(data.confirmAddress == true && data.systemsProtected == true  && data.systemsEncryption == true  && 
      data.customerInformation == true  && data.picturesOfFence == true  && data.fireExtinguisher == true  && data.shreddingDocument == true &&
      data.keyStorage == true  && data.personalStorage == true  && data.personalPropertyRemoved == true  &&  data.noGuardAllowed == true){
        this.remediationNeeded= false;
    }else{
      this.remediationNeeded= true;
    }
    const body = {
      "LocationId": locationId,
      "InspectedDate": (data.InspectedDate == '') ? '' : this.incidentTimeZone(data.InspectedDate),
      "ConfirmAddress": (data.confirmAddress == true) ? 'Yes' : 'No',
      "ComputerDataSecurity": {
        "PasswordProtected": (data.systemsProtected == true) ? 'Yes' : 'No',
        "DevicesEncrypted": (data.systemsEncryption == true) ? 'Yes' : 'No',
        "IsCustomerInfoPresent": (data.customerInformation == true) ? 'Yes' : 'No',
        "CDSDescription": (data.CDSDescription !== '') ? data.CDSDescription : '',
        "CDSDocumentName": (documentData[0].FileName !=='')? documentData[0].FileName: '',
        "CDSDocumentLink": (documentData[0].documentLink !== null)? documentData[0].documentLink :'' 
      },
      "Gated_or_Secured": {
        "Is_Gated_or_Secured": (data.picturesOfFence == true) ? 'Yes' : 'No',
        "GSDescription": (data.GSDescription !== '') ? data.GSDescription : '',
        "GSDocumentName": (documentData[1].FileName !=='')? documentData[1].FileName: '',
        "GSDocumentLink": (documentData[1].documentLink !== null)? documentData[1].documentLink :''
      },
      "FireProtection": {
        "IsFireProtection": (data.fireExtinguisher == true) ? 'Yes' : 'No',
        "FPDescription":(data.FPDescription !== '') ? data.FPDescription : '',
        "FPDocumentName": (documentData[3].FileName !=='')? documentData[3].FileName: '',
        "FPDocumentLink": (documentData[3].documentLink !== null)? documentData[3].documentLink :''
      },
      "ShreddingSystem": {
        "IsShreddingSystem": (data.shreddingDocument == true) ? 'Yes' : 'No',
        "SSDescription": (data.SSDescription !== '') ? data.SSDescription : '',
        "SSDocumentName": (documentData[4].FileName !=='')? documentData[4].FileName: '',
        "SSDocumentLink": (documentData[4].documentLink !== null)? documentData[4].documentLink :''
    },
    "KeyStorage": {
        "IsKeyStorage": (data.keyStorage == true) ? 'Yes' : 'No',
        "KSDescription": (data.KSDescription !== '') ? data.KSDescription : '',
        "KSDocumentName": (documentData[2].FileName !=='')? documentData[2].FileName: '',
        "KSDocumentLink": (documentData[2].documentLink !== null)? documentData[2].documentLink :''
    },
    "PersonalProperty": {
        "PPStorage":  (data.personalStorage == true) ? 'Yes' : 'No',
        "PPRemoved": (data.personalPropertyRemoved == true) ? 'Yes' : 'No',
        "PPDescription": (data.PPDescription !== '') ? data.PPDescription : '',
        "PPDocumentName": (documentData[5].FileName !=='')? documentData[5].FileName: '',
        "PPDocumentLink": (documentData[5].documentLink !== null)? documentData[5].documentLink :''
    },
      "DogsAllowed": (data.noGuardAllowed == true) ? 'Yes' : 'No',
      "Notes": (data.Notes !== '') ? data.Notes : '',
      "CreatedBy": loginId,
      "UpdatedBy": loginId,
      "RemediationNeeded" : (this.remediationNeeded === false)? 'No' :'Yes'
    };
    return this.httpClient.put(this.url + this.getCheckListData + locationId + '/' + agentId, body)
      .catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/location-checklist/location-checklist.service.ts